<mat-list>
  @for (navigationItem of navigationItems; track navigationItem) {
    <mat-list-item
      (keyup.space)="onSelectItem(navigationItem.route)"
      (click)="onSelectItem(navigationItem.route)"
      [routerLink]="navigationItem.route">
      <div class="navigation__label" matLine [class.] [class.font-bold]="router.url.includes(navigationItem.route)">
        {{ navigationItem.label | translate }}
      </div>
    </mat-list-item>
    <p class="horizontal-ruler" tabindex="-1"></p>
  }
</mat-list>
